import * as service from './service'

export default {
  namespace: 'helmetAuditHelmetGather',
  state: {
    demoData: {}
  },
  effects: {
    * auditInfo ({ payload }, { call, put }) {
      const res = yield call(service.auditInfo, payload)
      return res.data
    },
    * upload ({ payload }, { call, put }) {
      const res = yield call(service.upload, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
